module.exports = __webpack_public_path__ + "static/media/waybill-air.0ca8fbb3.webp";